// extracted by mini-css-extract-plugin
module.exports = {"container":"SectionContainer_container__3pf3q","title":"SectionContainer_title__3dmDh","content":"SectionContainer_content__2lzrx"};